import {
  CORE_LOAD_ALL_DEVICE_REQUEST,
  CORE_LOAD_ALL_DEVICE_SUCCESS,
  CORE_LOAD_ALL_DEVICE_FAILURE,

  CORE_LOAD_DEVICE_REQUEST,
  CORE_LOAD_DEVICE_SUCCESS,
  CORE_LOAD_DEVICE_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allDevice: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_DEVICE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_DEVICE_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_DEVICE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  deviceInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_DEVICE_REQUEST:
        return requestState
      case CORE_LOAD_DEVICE_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_DEVICE_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerDevice.js